import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, RecipientActionCreators, ITransplantedRecipientListResponse, IRecipientSearchRequest } from '@nkr/store/index';
import { ITransplantedRecipient } from '@nkr/models/index';
import TransplantedRecipientList from './grid';
import RecipientNav from '../recipient-nav';
import Search from '../list/center/search';

interface IOwnProps {
    centerId: number
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getTransplantedRecipients: (request: IRecipientSearchRequest) => Promise<ITransplantedRecipientListResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    list: ITransplantedRecipient[],
    alias: string,
    firstName: string,
    lastName: string,
    email: string,
    startDate: string,
    endDate: string,
    typeList: string[],
    voucherType: string,
    container: any
}

class TransplantedRecipients extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        alias: '',
        firstName: '',
        lastName: '',
        email: '',
        startDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        typeList: ['direct', 'paired', 'voucher', 'wlp'],
        voucherType: '',
        container: React.createRef()
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(''), { arrayFormat: 'bracket' });

        let alias = parsed.alias != null ? parsed.alias : this.state.alias;
        let firstName = parsed.firstName != null ? parsed.firstName : this.state.firstName;
        let lastName = parsed.lastName != null ? parsed.lastName : this.state.lastName;
        let email = parsed.email != null ? parsed.email : this.state.email;
        let typeList = parsed.type != null ? parsed.type : this.state.typeList;
        let startDate = parsed.startDate != null ? parsed.startDate : this.state.startDate;
        let endDate = parsed.endDate != null ? parsed.endDate : this.state.endDate;
        let voucherType = parsed.voucherType != null ? parsed.voucherType : this.state.voucherType;

        let request: IRecipientSearchRequest = {
            centerId: this.props.centerId,
            statusList: null,
            typeList,
            voucherType,
            alias,
            firstName,
            lastName,
            email,
            startDate,
            endDate
        };

        this.props.showLoading('Getting Transplanted Recipients, one moment please...').then(() => {
            this.props.getTransplantedRecipients(request)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            list: response.data.results,
                            alias,
                            typeList,
                            voucherType,
                            startDate,
                            endDate
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    setUrlParameters = () => {
        let { alias, firstName, lastName, email, typeList, voucherType, startDate, endDate } = this.state;

        let paramList = [];

        if (typeList.indexOf('direct') >= 0) {
            paramList.push('type[]=direct');
        }

        if (typeList.indexOf('paired') >= 0) {
            paramList.push('type[]=paired');
        }

        if (typeList.indexOf('voucher') >= 0) {
            paramList.push('type[]=voucher');
        }

        if (typeList.indexOf('wlp') >= 0) {
            paramList.push('type[]=wlp');
        }

        if (typeList.indexOf('krc') >= 0) {
            paramList.push('type[]=krc');
        }

        if (voucherType != '') {
            paramList.push('voucherType=' + voucherType);
        }

        if (alias != '') {
            paramList.push('alias=' + alias);
        }

        if (firstName != '') {
            paramList.push('firstName=' + firstName);
        }

        if (lastName != '') {
            paramList.push('lastName=' + lastName);
        }

        if (email != '') {
            paramList.push('email=' + email);
        }

        if (startDate != '') {
            paramList.push('startDate=' + startDate);
        }

        if (endDate != '') {
            paramList.push('endDate=' + endDate);
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/recipients/transplanted-recipients?' + params

        window.history.pushState({}, '', newUrl);
    }

    handleSearchFieldChange = (field: string, value: any) => {
        if (field == 'alias') {
            this.setState({ alias: value });
        }

        if (field == 'firstName') {
            this.setState({ firstName: value });
        }

        if (field == 'lastName') {
            this.setState({ lastName: value });
        }

        if (field == 'email') {
            this.setState({ email: value });
        }

        if (field == 'startDate') {
            this.setState({ startDate: value });
        }

        if (field == 'endDate') {
            this.setState({ endDate: value });
        }

        if (field == 'typeList') {
            this.setState({ typeList: value });
        }

        if (field == 'voucherType') {
            this.setState({ voucherType: value });
        }
    }

    handleSearch = () => {
        if (this.state.typeList.length == 0) {
            this.setState({
                typeList: ['direct', 'paired', 'voucher', 'wlp']
            }, () => {
                this.setUrlParameters();
                this.getData();
            })
        } else {
            this.setUrlParameters();
            this.getData();
        }
    }

    render = () => {
        return (
            <div style={{ padding: '0px 10px' }} ref={this.state.container}>
                <RecipientNav
                    activeKey={'TRANSPLANTED-RECIPIENTS'}
                    isAdmin={false}
                    isNkrLogin={true}
                    centerId={this.props.centerId}
                    recipientAlias={''}
                    recipientId={0}
                />

                <Search
                    alias={this.state.alias}
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    email={this.state.email}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    transplanted={true}
                    statusList={[]}
                    typeList={this.state.typeList}
                    voucherType={this.state.voucherType}
                    onFieldChange={this.handleSearchFieldChange}
                    onSearch={this.handleSearch}
                />

                <TransplantedRecipientList
                    list={this.state.list}
                    isSuperUser={true}
                    centerId={this.props.centerId}
                    container={this.state.container}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getTransplantedRecipients: (request) => {
            return dispatch(RecipientActionCreators.getTransplantedRecipients(request));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(TransplantedRecipients);